import { TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React from "react";
import dayjs from "dayjs";

interface IDatePicker {
    label: string | null | undefined,
    value?: Date | string | null | undefined,
    helperText?: string | null | undefined,
    onChange?: (value: string | null) => void,
    onBlur?: () => void,
    readonly?: boolean,
    variant?: "outlined" | "filled" | "standard" | undefined,
    nullable?: boolean,
    required?: boolean,
    disabled?: boolean
}

export const DatePicker: React.FC<IDatePicker> = ({
    value,
    onChange,
    onBlur,
    helperText,
    readonly,
    label,
    variant,
    nullable = true,
    required,
    disabled,
    ...props
}: IDatePicker) => {


    const getDefaultValue = () => {
        if (nullable) return null;
        else return new Date();
    }

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="en"
        >
            <MuiDatePicker
                label={label}
                value={value ? value : getDefaultValue()}
                inputFormat="DD/MM/YYYY"
                disabled={disabled}
                onChange={(date: any) => onChange ? onChange(date?.$d) : {}}
                renderInput={(params) =>
                    <TextField {...params}
                        variant={variant}
                        helperText={helperText}
                        required={required}
                        onBlur={onBlur}
                       
                    />
                }
                {...props}
            />
        </LocalizationProvider>
    );
}